module.exports = __webpack_public_path__ + "static/media/mem8YaGs126MiZpBA-UFWJ0bbck.e755c8ea.woff2";